import { render } from "./CreateAttributeModal.vue?vue&type=template&id=246a32e9"
import script from "./CreateAttributeModal.vue?vue&type=script&lang=js"
export * from "./CreateAttributeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__